export const selectDrupalStaticData = state => state?.drupalStaticData || {};
